module.exports = __webpack_public_path__ + "static/media/mobileLogo.f8a3ade0.png";